<template>
  <div id="receiptData">
    <body style="font-size: 12pt">
      <div id="page-wrap">
        <div class="row mb-12">
          <div class="col-lg-12" style="text-align: center">
            <img
              v-if="imagelink"
              style="height: 100px; width: 100px"
              :src="imagelink"
            />
          </div>
          ChequeDetails {{ chequeDetails }}
          <div class="col-lg-12" style="text-align: center">
            <h3>
              <b
                >Subject: Letter of Acknowledgement of Cheque Payment
                Received</b
              >
            </h3>
          </div>
        </div>

        <!-- <hr style="border-top: 1px dashed black;" /> -->

        <div class="row">
          <div class="col-lg-12" style="text-align: left">
            <b>Dear Sir or Madam, </b>
            <br />
          </div>
          <div class="col-lg-12" style="text-align: left">
            <p>
              This is to acknowledge receipt of your payment for goods supplied.
              we have Received the full Payment of order number 564, which was
              supplied last month. we look forward to a business relationship
              between both of the companies in the future
            </p>
            <br />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12" style="text-align: left">
            <b>.................................</b>
            <br />
          </div>
          <div class="col-lg-12" style="text-align: left">
            Signature
            <br />
          </div>
        </div>

        <p style="page-break-after: auto"></p>

        <div style="text-align: center">
          <p style="font-weight: bold">Thank You</p>
          <p>Powered by &#169;www.speedcodelabs.com || &#9742; 0212211599</p>
        </div>
        <p style="page-break-after: always"></p>
      </div>
    </body>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      ReservationDetails: [],
      datas: [],
    };
  },
  computed: {
    ...mapState(['chequeDetails']),
    ...mapState(['imagelink']),
  },
  props: {
    ChequeDetails: {
      type: Object,
      default: {},
    },
  },
  methods: {
    print() {
      this.$htmlToPaper('receiptData');
      // this.datas= this.ChequeDetails;
    },
  },
};
</script>
<style scoped>
table {
  margin: 40px 0px;
  font-size: 1rem;
  color: #333;
  font-weight: 700;
  border: 1px solid #333;
  background-color: #fff;
  width: 100%;
  text-align: center;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 15px 15px 15px 15px;
  overflow: hidden;
}

table thead {
  background-color: #333;
  font-size: 2rem;
  color: #fff;
  letter-spacing: 0.3rem;
}

table td,
table th {
  border-bottom: 1px solid #333 !important;
  height: 60px;
  width: calc(100% / 7);
  vertical-align: middle !important;
}

table thead th + th,
table tbody td {
  border-right: 1px solid #333 !important;
}

table tbody td:nth-child(6) {
  border-right: none;
}

table th {
  font-size: 14px;
}

table td,
table th {
  height: 50px;
}
</style>
